<div class="module-page-padding">
  <div class="main-view-shell">
    <!-- Mientras se resuelve el menú del usuario no sabemos qué productos mostrar: en vez de
         pintar todas las tarjetas y luego recortarlas, se muestra un esqueleto de carga. -->
    <div *ngIf="isLoadingServices; else servicesSection">
      <h4 class="font-semibold mb-2">Gestión de Servicios</h4>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <p-skeleton *ngFor="let _ of serviceSkeletons" height="150px" borderRadius="12px"></p-skeleton>
      </div>
    </div>

    <ng-template #servicesSection>
      <div *ngIf="hasVisibleServices">
        <h4 class="font-semibold mb-2">Gestión de Servicios</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <app-service-management-card
            *ngFor="let service of services; trackBy: trackByServiceId"
            [service]="service"
            [loading]="isLoadingMetrics"
            [canManageDevices]="canManageDevices(service.id)"
            [canManageModels]="canManageModels(service.id)"
            (manageClients)="onManageClients($event)"
            (manageDevices)="onManageDevices($event)"
            (manageModels)="onManageModels($event)"
          ></app-service-management-card>
        </div>
      </div>
    </ng-template>
  </div>
</div>
